/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import MobileSidebar from './components/mobile'
import DesktopSidebar from './components/desktop'
import { SidebarProvider } from './provider'
import type { SidebarProps } from './types'

const Sidebar = ({ sections }: SidebarProps) => {
	return (
		<SidebarProvider sections={sections}>
			<MobileSidebar sections={sections} />
			<DesktopSidebar sections={sections} />
		</SidebarProvider>
	)
}

export { Sidebar }
